<template>
  <div>
    <form autocomplete="off" class="flex" @submit.prevent="getResults">
      <input
        class="search-textbox body-10 focus:outline-none pl-6"
        type="text"
        placeholder="Search"
        v-model="query"
      />
      <button class="search-button flex items-center">
        <img class="mx-auto" alt="search" src="../../assets/images/search-icon.svg"/>
      </button>
    </form>
  </div>
</template>

<script>
  import { isDefined } from '@/common/utils/utils';

  export default {
    name: 'LernerSearch',

    data() {
      return {
        error: false,
        query: '',
      }
    },

    watch: {
      '$route': 'clearQuery'
    },

    created () {
      const routeQuery = this.$route.query;

      if (routeQuery && isDefined(routeQuery.s)) {
        this.query = routeQuery.s;
      }
    },

    methods: {
      getResults: function() {
        if (!this.query.length) {
          return false;
        }

        const query = {
          s: this.query,
          page: 1
        };

        this.$router.push({name: 'searchResults', query: query})
      },

      clearQuery: function () {
        if (this.$route.name !== 'searchResults') {
          this.query = '';
        }
      }
    }
  }
</script>

<style lang="scss" scoped>

  @keyframes rotate {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }

  .search-textbox {
    width: 300px;
    height: 46px;
    border: 4px solid lightgrey;
    border-right: none;
  }

  .list {
    @apply bg-white z-10 list-reset absolute;
    width: 300px;

    li {
      border: 1px solid lightgrey;
      border-top: none;
      @apply flex items-center cursor-default text-black w-full;

      &:hover {
        background-color: #f0f0f0;
        @apply cursor-default;
      }

      a {
        @apply w-full;
        padding: 8px 0 8px 35px;
      }
    }
  }

  .search-button {
    width: 50px;
    height: 46px;
    border-radius: 0 50px 50px 0;
    background-color: lightgrey;

    &:focus {
      @apply outline-none;
    }

    img {
      width: 24px;
      height: 24px;
    }
  }
</style>
